import { useQuery } from '@tanstack/react-query';
import { isString } from '../../../../../common/utils/is-string/is-string';
import { storageQueryKeys } from '../../../query-keys';
import { useIsAuthenticated } from '../../../../auth/context/AuthProvider/hooks/useIsAuthenticated/useIsAuthenticated';

export const useStorageFileByIdQuery = (
  fileId: string,
  {
    isEnabled = true,
    withSignedUrl = true,
  }: {
    isEnabled?: boolean;
    withSignedUrl?: boolean;
  } = {
    isEnabled: true,
    withSignedUrl: true,
  },
) => {
  const isAuthenticated = useIsAuthenticated();

  return useQuery({
    ...storageQueryKeys.fileById({
      fileId,
      withSignedUrl,
    }),
    enabled: isEnabled && isString(fileId) && !!fileId?.length && isAuthenticated,
    // Removed staleTime: Infinity to allow refetching when presigned URLs expire
    // Presigned URLs expire after 30 minutes, so we need to refetch on errors
    staleTime: withSignedUrl ? 25 * 60 * 1000 : Infinity, // 25 minutes for signed URLs (5 min before 30 min expiry)
    refetchInterval: false,
    // Retry on 500 errors (expired presigned URLs) to get fresh URLs
    retry: (failureCount, error: any) => {
      // Retry up to 2 times for 500 errors (likely expired presigned URL)
      if (error?.status === 500 || error?.response?.status === 500) {
        return failureCount < 2;
      }
      // Don't retry other errors
      return false;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
  });
};
